import ConfirmationDialog from 'components/ConfirmationDialog'
import { ModalInjectedProps } from 'containers/ModalManager'
import React from 'react'

import { useToast } from 'containers/ToastManager'
import { useEmptyWorkspaceTrash } from 'modules/shares/operations/useEmptyWorkspaceTrash'

interface EmptyTrashModalProps extends ModalInjectedProps {
  workspaceId: string
}

export const EmptyTrashModal: React.FC<EmptyTrashModalProps> = props => {
  const { hideModal, isModalOpen, workspaceId } = props
  const { showToast } = useToast()

  const [emptyTrash, { loading }] = useEmptyWorkspaceTrash({
    onCompleted: () => {
      showToast('Trash emptied')
      hideModal()
    },
    onError: message => showToast(message, 'negative'),
    identifier: workspaceId,
  })

  return (
    <ConfirmationDialog
      title="Empty Trash?"
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      cancelButton={{
        disabled: loading,
      }}
      confirmButton={{
        text: 'Empty Trash',
        variant: 'negative',
        loading,
        disabled: loading,
      }}
      onConfirm={() => emptyTrash()}>
      <p>
        Permanently delete all Workspace documents in Trash, including all
        activity and history? This action cannot be undone.
      </p>
    </ConfirmationDialog>
  )
}
